import en from "@/languages/locales/en.json"
import bg from "@/languages/locales/bg.json"

export default {
  en,
  bg
}
